// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"49e82dbd","84":"49e82dbd","714":"1b364aa0","809":"49e82dbd","936":"49e82dbd"}[chunkId] + ".chunk.css";
};